import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var ResidentRelations =
/*#__PURE__*/
function () {
  function ResidentRelations() {
    _classCallCheck(this, ResidentRelations);
  }

  _createClass(ResidentRelations, null, [{
    key: "GetResidentRelationsProjectList",
    value: function GetResidentRelationsProjectList(year, userId, month, issueType) {
      return axios.get("/api/ResidentRelations/GetResidentRelationsProjectList", {
        params: {
          year: year,
          userId: userId,
          month: month,
          issueType: issueType
        }
      });
    }
  }, {
    key: "CreateResidentRelations",
    value: function CreateResidentRelations(residentRelations) {
      return axios.post("/api/ResidentRelations/CreateResidentRelations", residentRelations);
    }
  }, {
    key: "SendUserResponsibleEmail",
    value: function SendUserResponsibleEmail(residentRelations) {
      return axios.post("/api/ResidentRelations/SendUserResponsibleEmail", residentRelations);
    }
  }, {
    key: "NotifyManagement",
    value: function NotifyManagement(residentRelations) {
      return axios.post("/api/ResidentRelations/NotifyManagement", residentRelations);
    }
  }, {
    key: "UpdateResidentRelations",
    value: function UpdateResidentRelations(residentRelations) {
      return axios.patch("/api/ResidentRelations/UpdateResidentRelations", residentRelations);
    }
  }, {
    key: "GetResidentRelationsByProjectId",
    value: function GetResidentRelationsByProjectId(projectId) {
      return axios.get("/api/ResidentRelations/GetResidentRelationsByProjectId/".concat(projectId));
    }
  }, {
    key: "GetResidentRelationsByResidentRelationsId",
    value: function GetResidentRelationsByResidentRelationsId(selectedResidentRelationsId) {
      return axios.get("/api/ResidentRelations/GetResidentRelationsByResidentRelationsId/".concat(selectedResidentRelationsId));
    }
  }, {
    key: "GetResidentRelationsHistory",
    value: function GetResidentRelationsHistory(projectId, numYears) {
      return axios.get("/api/ResidentRelations/GetResidentRelationsHistory/".concat(projectId, "/").concat(numYears));
    }
  }, {
    key: "GetProjectListDropdownValues",
    value: function GetProjectListDropdownValues() {
      return axios.get("/api/ResidentRelations/GetProjectListDropdownValues");
    }
  }, {
    key: "GetResidntRelationUsers",
    value: function GetResidntRelationUsers() {
      return axios.get("/api/ResidentRelations/GetResidntRelationUsers");
    }
  }]);

  return ResidentRelations;
}();

export { ResidentRelations as default };